export default __webpack_public_path__ + "e10c75b6072c190492ca00c474fd2dff.png";